module.exports = __webpack_public_path__ + "img/P4-1-2.3cee3f77.svg";